import { useAuth } from '../../hooks/useAuth';
import {
  HomeIcon,
  DocumentTextIcon,
  ShieldCheckIcon,
  ArrowRightOnRectangleIcon,
  UserCircleIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';

type Route = '/' | '/callback' | '/reports' | '/network' | '/costs';

interface HeaderProps {
  onNavigate?: (route: Route) => void;
}

export function Header({ onNavigate }: HeaderProps) {
  const { user, logout } = useAuth();
  const currentPath = window.location.pathname;

  const navLink = (path: Route, label: string, Icon: React.ElementType) => {
    const active = currentPath === path;
    return (
      <button
        onClick={() => onNavigate?.(path)}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
          active
            ? 'text-white'
            : 'text-blue-200 hover:text-white hover:bg-white/10'
        }`}
        style={active ? { background: 'rgba(224, 90, 28, 0.85)' } : {}}
      >
        <Icon className="h-4 w-4" />
        {label}
      </button>
    );
  };

  return (
    <header style={{ background: 'linear-gradient(90deg, #0f1c3f 0%, #1B2B6B 60%, #1e3070 100%)' }} className="shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-18 py-3">
          {/* Logo + title */}
          <div className="flex items-center gap-4">
            <div className="flex items-center">
              <img
                src="/logo-honne.png"
                alt="Honne - Delivering True Value"
                className="h-12 w-auto"
              />
            </div>
            <div className="h-8 w-px" style={{ background: 'rgba(255,255,255,0.15)' }} />
            <div>
              <h1 className="text-base font-bold text-white tracking-wide">
                Honne Automated Reports
              </h1>
              <p className="text-xs font-medium" style={{ color: '#5B8DB8' }}>
                Cloud Cost Optimization
              </p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navLink('/', 'Dashboard', HomeIcon)}
            {navLink('/reports', 'Reportes', DocumentTextIcon)}
            {navLink('/costs', 'Costos', CurrencyDollarIcon)}
            {navLink('/network', 'Análisis de Red', ShieldCheckIcon)}
          </nav>

          {/* User info + logout */}
          <div className="flex items-center gap-3">
            {user && (
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(255,255,255,0.08)' }}>
                <UserCircleIcon className="h-5 w-5 text-blue-300" />
                <span className="text-sm text-white hidden sm:block font-medium">{user.name || user.email}</span>
              </div>
            )}
            <button
              onClick={logout}
              className="flex items-center gap-1.5 text-blue-200 hover:text-white text-sm px-3 py-1.5 rounded-lg transition-all duration-200 hover:bg-white/10"
              title="Cerrar sesión"
            >
              <ArrowRightOnRectangleIcon className="h-4 w-4" />
              <span className="hidden sm:block">Salir</span>
            </button>
          </div>
        </div>
      </div>
      {/* Bottom accent line */}
      <div className="h-0.5 w-full" style={{ background: 'linear-gradient(90deg, #1B2B6B 0%, #5B8DB8 40%, #E05A1C 70%, #1B2B6B 100%)' }} />
    </header>
  );
}
